<h3>{{'ALARMAS.SHARE_MESSAGE' | translate}} </h3>

<mat-form-field class="users-chip-list">
    <mat-chip-list #chipList aria-label="User selection" class="users-chip-list">
        <mat-chip color="primary"
          *ngFor="let user of users"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(user)">
          {{user}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input 
          placeholder="..."
          #userInput
          [formControl]="userCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
          {{user}}
        </mat-option>
      </mat-autocomplete>
</mat-form-field>

<div class="mt-3">
    <button mat-raised-button [mat-dialog-close]>{{'DASHBOARD.FORM.CANCEL' | translate}}</button>
    <button [disabled]="users.length <= -1 " mat-raised-button color="primary" class="right" [mat-dialog-close]="usersSelected"
        cdkFocusInitial>{{'DASHBOARD.FORM.ACCEPT' | translate}}</button>
</div>